import { HiOutlineTrash } from "react-icons/hi";

export default function DeleteBtn({ onClick, label }) {
  return (
    <button
      onClick={onClick}
      className="h-5 w-5 text-red-400 hover:text-red-700 transition transform hover:scale-110"
      title={label}
    >
      <HiOutlineTrash className="w-5 h-5" />
    </button>
  );
}
